/**
 * Drapeaux booléens venant de la base — source unique de lecture.
 * ==============================================================
 *
 * LE FAIT QUI JUSTIFIE CE FICHIER (mesuré le 2026-09-12)
 *
 * Un drapeau (`is_current`, `is_active`, `is_primary`, `is_enabled`, `is_default`…) n'arrive
 * PAS sous la même forme selon la table et selon le moteur :
 *
 *   - PostgreSQL colonne `boolean`  → l'API rend `true` / `false`
 *   - PostgreSQL colonne `integer`  → l'API rend `1` / `0`
 *   - SQLite (dev local, mobile)    → `1` / `0`
 *
 * Et le MÊME NOM de colonne n'a pas le même type d'une table à l'autre : `is_active` est
 * `boolean` dans 20 tables et `integer` dans 4 ; `is_enabled` dans 7 et 2 ; `is_default`
 * dans 1 et 1. Aucune comparaison stricte n'est donc juste partout — ni `=== 1`, ni
 * `=== true`.
 *
 * Ce que ça coûtait concrètement : `filter(l => l.is_current === 1)` sur une colonne
 * booléenne ne rend JAMAIS rien. La modale d'affectation de site ne clôturait donc jamais
 * l'affectation précédente et créait un DOUBLON à chaque usage (5 véhicules trouvés avec
 * deux affectations « courantes » simultanées). Rien ne plantait, rien n'alertait : le
 * filtre rendait poliment une liste vide.
 *
 * 🚫 NE JAMAIS écrire `row.is_xxx === 1`, `=== true`, `=== 0` ni `=== false` sur une valeur
 *    venue de la base. Toujours `isFlagOn(row.is_xxx)` / `isFlagOff(row.is_xxx)`.
 *    Un test au pre-push (`check_db_flag_comparisons.mjs`) refuse les retours en arrière.
 *
 * ⚠️ `isFlagOn` et `isFlagOff` ne sont PAS l'inverse l'un de l'autre : une valeur absente
 *    (`null`, `undefined`) n'est ni allumée ni éteinte. C'est délibéré — « pas de valeur »
 *    et « valeur fausse » ne veulent pas dire la même chose pour un drapeau qu'on s'apprête
 *    à écrire ou à clôturer.
 */

/** Le drapeau est-il ACTIF ? Accepte `true`, `1`, `'1'`, `'true'`, `'t'`. */
export function isFlagOn(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    return v === '1' || v === 'true' || v === 't' || v === 'yes';
  }
  return false;
}

/** Le drapeau est-il explicitement INACTIF ? `null`/`undefined` ⇒ false (voir l'avertissement). */
export function isFlagOff(value) {
  if (value === false || value === 0) return true;
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    return v === '0' || v === 'false' || v === 'f' || v === 'no';
  }
  return false;
}

export default { isFlagOn, isFlagOff };
